"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("./Button.js"));

var _Flex = _interopRequireDefault(require("./Flex.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _String = _interopRequireDefault(require("./String.js"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a numeric value with increment/decrement controls
 */
class Counter extends _react.default.PureComponent {
  /**
   * Value changed.
   *
   * @param {Integer} value Incremented/decremented value
   * @return {void}
   */
  handleChange = value => this.props.onChange?.(value, this.props.name);
  /**
   * Render.
   * 
   * @return {ReactNode}
   */

  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      alignItems: "center",
      columnar: true,
      gap: this.props.gap,
      ...this.props.FlexProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: this.props.buttonColor,
        disabled: this.props.disabled || this.props.value <= this.props.min,
        label: "-",
        onClick: this.handleChange,
        size: this.props.buttonSize,
        value: this.props.value - 1,
        variant: this.props.buttonVariant,
        ...this.props.ButtonProps
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        centre: true,
        color: this.props.textColor,
        noFlex: true,
        str: `${this.props.value} ${this.props.label || ""}`.trim(),
        ...this.props.LabelStringProps
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: this.props.buttonColor,
        disabled: this.props.disabled || this.props.value >= this.props.max,
        label: "+",
        onClick: this.handleChange,
        size: this.props.buttonSize,
        value: this.props.value + 1,
        variant: this.props.buttonVariant,
        ...this.props.ButtonProps
      })]
    });
  }

  static propTypes = {
    ButtonProps: _propTypes.default.object,
    FlexProps: _propTypes.default.object,
    LabelStringProps: _propTypes.default.object,
    buttonColor: _propTypes.default.oneOf(["primary", "secondary", "default", "inherit"]),
    buttonSize: _propTypes.default.oneOf(["small", "medium", "large"]),
    buttonVariant: _propTypes.default.oneOf(["text", "outlined", "contained"]),
    disabled: _propTypes.default.bool,
    gap: _propTypes.default.number,
    label: _propTypes.default.string,
    max: _propTypes.default.number,
    min: _propTypes.default.number,
    name: _propTypes.default.string,
    onChange: _propTypes.default.func,
    textColor: _propTypes.default.oneOf(["primary", "secondary", "textPrimary", "textSecondary", "error", "initial", "inherit"]),
    value: _propTypes.default.number
  };
  static defaultProps = {
    buttonColor: "primary",
    buttonSize: "large",
    buttonVariant: "outlined",
    disabled: false,
    gap: 2,
    min: 1,
    textColor: "textPrimary"
  };
}

var _default = Counter;
exports.default = _default;